import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Draggable from 'react-draggable';
import { RoundButton } from "../buttons/base/RoundButton";
import { CloseButton } from "../buttons/base/CloseButton";
import { useState, useRef, useEffect } from "react";
import { SimpleButton } from "../buttons/base/SimpleButton";

export function DraggableArea({ title, content, onOpen = () => {}, onClose, openIcon = "list-check", closeIcon = "times" }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const draggableRef = useRef(null);
  
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  }

  useEffect(() => {
    if (draggableRef.current) {
      const element = draggableRef.current as HTMLElement;
      const rect = element.getBoundingClientRect();
      console.log("Position before adjustment:", { top: rect.top, left: rect.left });

      if (rect.top < 0) {
        const currentTransform = window.getComputedStyle(element).getPropertyValue('transform');
        const matrix = new DOMMatrix(currentTransform);
        element.style.transform = `translate(${matrix.m41}px, 0px)`;
        console.log("Adjusted transform to keep top at 0");
      }

      const newRect = element.getBoundingClientRect();
      console.log("Position after adjustment:", { top: newRect.top, left: newRect.left });
    }
  }, [isExpanded]);

  const draggableStyle = isExpanded ? { width: "50vw", height: "95vh" } : { width: "33vw", height: "75vh" };
  const cardBodyStyle: React.CSSProperties = { overflowY: 'auto' };

  return (
    <span>
      { (!content) &&
        <RoundButton 
          icon={openIcon as any}
          className="m-1" 
          onClick={onOpen} 
          title={title}
        />
      }
      { content &&
        <Draggable handle=".draggable-header" nodeRef={draggableRef}>
          <div ref={draggableRef} className="shadow draggableArea card card-design" style={draggableStyle}>
            <div className="card-header draggable-header">
              <div className="row">
                <div className="text-start col-6"><FontAwesomeIcon icon={openIcon as any} /> {title}</div>
                <div className="text-end col-6">
                  <SimpleButton 
                    onClick={toggleExpanded}                     
                    title={title}
                  >
                    <FontAwesomeIcon icon={isExpanded ? "window-minimize" : "window-maximize" as any} />
                  </SimpleButton>
                  <CloseButton onClick={onClose} />
                </div>
              </div>
            </div>
            <div className="card-body" style={cardBodyStyle}>
              {content}
            </div>
          </div>
        </Draggable>
      }
    </span>
  );
}
